import { Box, SearchField, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import MultipleChoice from 'modules/core/components/Filter/filters/MultipleChoice'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useIntegrationsCatalog } from 'modules/marketplace/components/IntegrationList/IntegrationsCatalogProvider'
import { locale } from 'modules/marketplace/components/utils/locales'
import { useGetMarketplaceIntegrationCountries } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrationCountries'

export const Filters = () => {
  const {
    access: { locale: user_locale },
  } = useCurrentSession()
  const datoFormatLocale = locale[user_locale]

  const {
    categories,
    search,
    installedFilter,
    categoryFilter,
    filterByCategory,
    countryFilter,
    installedFilterToggle,
    filterByCountry,
  } = useIntegrationsCatalog()

  const { data: integrationCountriesData } = useGetMarketplaceIntegrationCountries({
    locale: datoFormatLocale,
  })

  useEffect(() => {
    search.debouncedSearch && sendSearchedTextSearchBarTrackEvent(search.debouncedSearch)
  }, [search.debouncedSearch])

  const buildMultipleChoiceOptionsFromCategories = () =>
    categories.map((category) => ({
      label: category.title,
      value: category.id,
    }))

  const buildMultipleChoiceOptionsFromCountries = () =>
    integrationCountriesData.map((country) => ({
      label: country.name,
      value: country.id,
    }))

  const sendOnFocusSearchBarTrackEvent = () => {
    track(trackingEvents.marketplace.focusOnSearchBar)
  }

  const sendSearchedTextSearchBarTrackEvent = (text: string) => {
    track(trackingEvents.marketplace.searchTextOnSearchBar, {
      searched_text: text,
    })
  }

  return (
    <Box width="full" justifyContent="flexEnd" flexDirection="row">
      <Box width="full" justifyContent="flexStart" flexDirection="row" paddingX="s32" gap="s8">
        <MultipleChoice
          label={i18n.t('marketplace.filters.category')}
          hideSearch
          value={categoryFilter}
          onValueChange={filterByCategory}
          options={buildMultipleChoiceOptionsFromCategories()}
        />
        {integrationCountriesData?.length > 0 && (
          <MultipleChoice
            label={i18n.t('marketplace.filters.country')}
            hideSearch
            value={countryFilter}
            onValueChange={filterByCountry}
            options={buildMultipleChoiceOptionsFromCountries()}
          />
        )}
        <TogglerCheckbox
          labelWeight="medium"
          value={installedFilter}
          onChange={installedFilterToggle}
          label={i18n.t('marketplace.filters.installed_toggle_label')}
        />
      </Box>
      <Box width="sidebar" paddingX="s48">
        <SearchField
          onSearch={search.onSearch}
          search={search.search}
          placeholder={i18n.t('common.search')}
          onFocus={sendOnFocusSearchBarTrackEvent}
        />
      </Box>
    </Box>
  )
}
